<mat-form-field
    [ngClass]="input_classHeight$$()"
    [class.show-error]="!!input_error$$()"
    [appearance]="input_appearance$$()"
    [floatLabel]="'always'"
    [hideRequiredMarker]="!input_required$$()"
    subscriptSizing="dynamic">

    @if (input_label$$()) {
        <mat-label>{{ input_label$$() }}:</mat-label>
    }
    <mat-chip-grid #chipGrid [attr.aria-label]="input_label$$()" [required]="input_required$$()">
        @for (item of input_items$$(); track trackChip($index, item)) {
            <mat-chip-row [removable]="input_removable$$() && !input_readonly$$()" (removed)="emit_chipRemove(item)">
                @if (item.icon) {
                    <app-icon matChipAvatar [name]="item.icon" size="1em" />
                }
                {{ item.label }}
                @if (input_removable$$() && !input_readonly$$()) {
                    <button matChipRemove type="button" [attr.aria-label]="input_removeTooltip$$()" [matTooltip]="input_removeTooltip$$()">
                        <app-icon name="xmark" size="0.9em" />
                    </button>
                }
            </mat-chip-row>
        } @empty {
            <span class="chips-control__empty">{{ input_emptyText$$() }}</span>
        }
    </mat-chip-grid>
    @if (input_suffixIcon$$() && !input_readonly$$()) {
        <button mat-icon-button matSuffix type="button"
            (click)="emit_suffixClick($event)"
            [attr.aria-label]="input_suffixTooltip$$()"
            [matTooltip]="input_suffixTooltip$$() ?? ''"
        >
            <mat-icon>{{ input_suffixIcon$$() }}</mat-icon>
        </button>
    }
    @if (input_error$$()) {
        <mat-error>{{ input_error$$() }}</mat-error>
    }
</mat-form-field>
